export default __webpack_public_path__ + "static/media/volkswagen2.8bdd1403.jpg";